import { Loader2 } from "lucide-react";
import { Navigate, Outlet } from "react-router";
import { useSessionState } from "@/hooks/use-session-state.ts";

export function GuestRoute() {
	const status = useSessionState();

	switch (status) {
		case "loading":
			return (
				<div className="route-loading">
					<Loader2 />
				</div>
			);
		case "onboarding":
			return <Navigate to="/onboarding" replace />;
		case "ready":
			return <Navigate to="/" replace />;
		default:
			return <Outlet />;
	}
}
